import { QUERY_GET_FACTORY_RATES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryRates = baseThunk(`factoryRates/getRates`, QUERY_GET_FACTORY_RATES, "GET")
